import React, { useState, useEffect, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";


let debounceTimer = null;

const ComparisonItemSearch = ({ comparisonType, entityType, uniqueId, closePopupFunction, selectComparisonItemFunction, systematicReviewType }) => {

    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [dataUrl, setDataUrl] = useState("");
    const [itemTypeName, setItemTypeName] = useState("");
    const [cmDateColName, setCmDateColName] = useState("");


    useEffect(() => {

        let srMainType = "";
        if (entityType == "systematic-reviews") {
            if (systematicReviewType.includes("authorities-news"))
                srMainType = "regulatory";
        }

        if (entityType == "compliance-regulatorydocuments" || srMainType == "regulatory") {
            setDataUrl("/umbraco/api/Compliance/RegulatoryDocumentsSearch");
            setItemTypeName("Regulation");
            setCmDateColName("PUB. DATE");
        }

        if (entityType == "compliance-standards" || srMainType == "standards") {
            setDataUrl("/umbraco/api/Compliance/StandardsSearch");
            setItemTypeName("Standard");
            setCmDateColName("YEAR");
        }


    }, []);




    useEffect(() => {

        if (dataUrl == "")
            return;

        // If it's a version comparison (gap or redline) search for all the versions immediately
        if (comparisonType == "comparison" || comparisonType == "redline")
            loadSearchResults();

    }, [dataUrl]);


    const doTextSearchTask = (textSearch) => {
        let debouncingTime = 500;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            loadSearchResults({ localSearch: textSearch, nextPage: false });
        }, debouncingTime);
    };




    const loadSearchResults = ({
        localSearch = search,
        nextPage = false,
    } = {}) => {

        if (isLoadingData) return;

        setIsLoadingData(true);

        let local_data = data;
        let local_data_page = currentPage;

        if (nextPage == false) {
            local_data = [];
            local_data_page = 1;
            setData(local_data);
            setCurrentPage(local_data_page);
            setHasMoreData(true);
        } else {
            local_data_page++;
            setCurrentPage(local_data_page);
        }


        if (dataUrl == "")
            return;

        // Ident from Surveillance is "{surveillanceId}.{uniqueId}" — uniqueId may contain dots
        if (uniqueId && uniqueId.includes("."))
            uniqueId = uniqueId.substring(uniqueId.indexOf(".") + 1);
        // Industry-prefixed ids (e.g. "1reg1431") → main id "reg1431" (same as CM)
        var mainUniqueIdMatch = uniqueId && uniqueId.match(/(fda.*|reg.*)/i);
        if (mainUniqueIdMatch)
            uniqueId = mainUniqueIdMatch[0];


        let loadDataURL = dataUrl + `?` +
            `search=${encodeURIComponent(localSearch)}&` +
            `page=${encodeURIComponent(local_data_page)}&` +
            `sortBy=&` +
            `sortType=&` +
            `pdfFilter=true&` + 
            `uniqueIdToCompare=${uniqueId}&` +
            `versionTracker=${comparisonType == "comparison" || comparisonType == "redline" ? "true" : "false"}`
            ;

        let requestOptions = {};

        fetch(loadDataURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));
                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // If no items returned it means there is no more data to retrieve
                if (result.length == 0)
                    setHasMoreData(false);
                else {
                    // Was it a fetch more request? Then append to data.
                    if (nextPage) {
                        let res = [...local_data, ...result];
                        setData(res);
                    } else {
                        setData(result);
                    }

                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setHasMoreData(false);
            })
            .finally(() => {
                setIsLoadingData(false);
            });


    };








    const targetRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [isLoadingData]);


    useEffect(() => {

        if (isVisible && hasMoreData && !isLoadingData) {
            loadSearchResults({ nextPage: true });
        }
    }, [isVisible]);





    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 1 }}>
                    {comparisonType == "comparison" || comparisonType == "redline" ? <>
                        <h3>Select other version of the document to compare with:</h3>
                    </> : null}
                    {comparisonType == "file-included" ? <>
                        <h3>Search for a {itemTypeName} to include in the prompt:</h3>
                    </> : null}

                </div>
                <div style={{ width: "50px", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={closePopupFunction}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>
            {/*<input
                value={search}
                className={`form-field-text`}
                onChange={(e) => { setSearch(e.target.value); doTextSearchTask(e.target.value); }}
                style={{ width: "100%" }}
                type="text"
                placeholder={`Search ${itemTypeName}`}
            />
            <br />
            <br />*/}
            

            {/* RESULTS LIST */}

            {data !== null && (
                <>
                    <div style={{ width: "100%", display: "flex", flexDirection: "row", borderBottom: "1px solid #f0f0f0", fontWeight: "bold", padding: "6px 0px" }}>
                        <div style={{ width: "50%" }}>NAME</div>
                        <div style={{ width: "15%" }}>TYPE</div>
                        <div style={{ width: "15%" }}>STAGE</div>
                        <div style={{ width: "10%" }}>{cmDateColName}</div>
                        <div style={{ width: "10%" }}>ACTIONS</div>
                    </div>

                    <div className="thin-scrollbar" style={{ width: "100%", maxHeight: "450px", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                        {data.length > 0 ? (
                            data.map((item, index) => {
                                let cmDateColValue = "";
                                if (entityType === "compliance-regulatorydocuments") cmDateColValue = item.Date;
                                if (entityType === "compliance-standards") cmDateColValue = item.Year;

                                return (
                                    <div key={index} className="results-table-row" style={{ width: "100%", display: "flex", padding: "6px 0px", flexDirection: "row", borderBottom: "1px solid #f0f0f0" }}>
                                        <div style={{ width: "50%" }}>{item.Name}</div>
                                        <div style={{ width: "15%" }}>{item.Type}</div>
                                        <div style={{ width: "15%" }}>{item.Stage}</div>
                                        <div style={{ width: "10%" }}>{cmDateColValue}</div>
                                        <div style={{ width: "10%" }}>
                                            <span
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "3px 7px",
                                                    border: "1px solid #999",
                                                    borderRadius: "5px",
                                                    backgroundColor: "#cbeeff"
                                                }}
                                                onClick={() => selectComparisonItemFunction(item.UniqueId, item.Name, item.MediaPdf, item.MedBoardResourceId, item.TranslationMediaPath)}
                                            >
                                                {comparisonType === "comparison" || comparisonType === "redline" ? "Compare" : null}
                                                {comparisonType === "file-included" ? "Select" : null}
                                            </span>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (!isLoadingData && (
                            <div style={{ padding: "30px 0px", color: "#a8a8a8", textAlign: "center", fontSize: "14px" }}>
                            No more versions found for this document with files attached
                                </div>
                            )
                        )}

                        <div style={{ marginBottom: "20px" }}>
                            {isLoadingData ? (
                                <div style={{ textAlign: "center" }}>
                                    <LoadingSpinnerImage />
                                </div>
                            ) : (
                                <div ref={targetRef} style={{ minHeight: "5px" }}></div>
                            )}

                            {!hasMoreData && data.length > 0 && (
                                <div className="no-more-results">No more results</div>
                            )}
                        </div>
                    </div>
                </>
            )}

            {/* BUTTONS */}

            <div className="action-button-bar" style={{position: "initial"}}>
                <div className="action-button-bar-left"></div>
                <div className="action-button-bar-center">
                    <button
                        className="action-button cancel-button"
                        onClick={closePopupFunction}
                    >
                        Close
                    </button>
                </div>
                <div className="action-button-bar-right"></div>
            </div>




        </div>
    );
};


export default ComparisonItemSearch;